import { useUserStore } from "../../store/userStore.js";
import { Progress } from "antd";
import moment from "moment";

import images from "../../assets";
import PrimaryButton from "../button/primarybutton";

import UserBasicInfo from "./userbasicinfo";

export default function UserProfile() {
  const { user } = useUserStore();

  return (
    <div className="w-full flex flex-col">
      <div
        style={{
          backgroundImage: `url(${images.pendingitemBg})`,
          backgroundPosition: "100% 100%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="w-full px-8 mb-4 pt-4 pb-8 rounded-2xl shadow border border-primary50 flex-col justify-center items-center gap-6 flex"
      >
        <p className="text-center text-white text-2xl font-semibold">
          Quick Overview
        </p>
        <div className="w-full justify-between items-center flex">
          <div className="w-[198px] h-[124px] p-4 bg-white/60 rounded-2xl shadow border border-primary50 flex-col justify-center items-center gap-[23px] flex">
            <p className="self-stretch  text-center text-textQuickOverview/50 text-base">
              Pending Requests
            </p>
            <div className="self-stretch justify-between items-end flex">
              <p className="text-textQuickOverview text-3xl font-semibold">
                {user?.pendingRequests ?? 0}
              </p>
              <div>
                <PrimaryButton
                  style={{
                    width: "112px",
                    height: "32px",
                    fontSize: "14px",
                  }}
                  text={"Review"}
                  iconalign="left"
                  icon={images.hyperlinkIcon}
                />
              </div>
            </div>
          </div>
          <div className="w-max p-4 bg-white/60 rounded-2xl shadow border border-primary50 flex-col justify-center items-center gap-2 flex">
            <div className="self-stretch  text-center text-textQuickOverview/50 text-base">
              Member since
            </div>
            <div className="self-stretch justify-center items-center flex">
              <div className="text-center text-textQuickOverview text-2xl font-semibold">
                {moment(user?.createdAt).format("MMM-DD-YYYY")}
              </div>
            </div>
            <div className="text-center text-textQuickOverview/50 text-sm ">
              {(() => {
                const createdAt = moment(user?.createdAt);
                const now = moment();
                const durationInMonths = now.diff(createdAt, "months");
                const remainingDays = now.diff(createdAt, "days");
                return `${durationInMonths} Months | ${remainingDays} days`;
              })()}
            </div>
          </div>
          <div className="w-80 px-4 py-3 bg-white/60 rounded-2xl shadow border border-primary50 flex-col justify-center items-center gap-2.5 flex relative">
            <div className="flex absolute -right-3 -top-3">
              <img src={images.infoIcon} alt="" />
            </div>
            <h4 className="self-stretch text-basePrimary font-semibold">
              Profile Completion Status
            </h4>
            <div className="w-full flex flex-col gap-1 items-start justify-start">
              <Progress
                showInfo={false}
                percent={user?.profileCompleteness}
                strokeColor="#17C964"
              />
              <p className="text-textQuickOverview text-xs  leading-[18px]">
                {user?.profileCompleteness}% Profile Completed
              </p>
            </div>
          </div>
        </div>
      </div>
      <UserBasicInfo />
    </div>
  );
}



